import React from 'react'
import Routes from 'routes'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { withApp, scrollTop } from 'helpers'
import { Page } from 'components/library'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'
import AspectArticle from './aspect/AspectArticle'
import AspectQuiz from './aspect/AspectQuiz'
import AspectExercise from './templates/AspectExercise'
import AspectPage from './templates/AspectPage'

class ChapterAspectView extends React.Component {
  componentDidMount() {
    scrollTop()

    this.setTheme()
    this.props.app.setLocation({ label: 'aspect', id: this.aspect.id })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.chapter !== this.props.match.params.chapter) {
      this.setTheme()
      scrollTop()
    }

    if(prevProps.match.params.aspect !== this.props.match.params.aspect) {
      scrollTop()
      this.props.app.setLocation({ label: 'aspect', id: this.aspect.id })
    }
  }

  setTheme() {
    const nav = this.props.navigation.find(item => item.chapterId === this.chapter.id)
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  get chapter() {
    return this.props.chapters.find(item => item.slug === this.props.match.params.chapter) || {}
  }

  get aspect() {
    if(this.chapter.id)
      return this.chapter.aspects.find(item => item.id === +this.props.match.params.aspect) || {}
    else
      return {}
  }

  get chapterData() {
    const data = this.props.chaptersData.find(item => item.cId === this.chapter.id && item.aId === this.aspect.id)
    return data ? data.data : null
  }

  handleBack = e => {
    let nextAspectId = this.aspect.id - 1
    let nextRoute = Routes.to('aspect', { chapter: this.chapter.slug, aspect: nextAspectId })

    if(nextAspectId < 1) {
      if(this.chapter.intro) {
        nextRoute = Routes.to('chapter', { chapter: this.chapter.slug })
      } else {
        let currentNavigationItem = this.props.navigation.find(item => item.chapterId === this.chapter.id)
        let currentNavigationItemIndex = this.props.navigation.indexOf(currentNavigationItem)

        currentNavigationItemIndex--
        currentNavigationItem = this.props.navigation[currentNavigationItemIndex]

        if(currentNavigationItem) {
          switch(currentNavigationItem.type) {
            case 'chapter':
              const prevChapter = this.props.chapters.find(item => item.id === currentNavigationItem.chapterId)
              const lastAspectId = prevChapter.aspects[prevChapter.aspects.length-1].id
              nextRoute = Routes.to('aspect', { chapter: prevChapter.slug, aspect: lastAspectId })
              break

            case 'page':
              nextRoute = Routes.to('page', { page: currentNavigationItem.slug })
              break

            default:
          }
        } else {
          nextRoute = Routes.to('home')
        }
      }
    }

    this.props.history.push(nextRoute)
  }

  handleNext = e => {
    let nextAspectId = this.aspect.id + 1
    let nextRoute = Routes.to('aspect', { chapter: this.chapter.slug, aspect: nextAspectId })
    let hasSummary = false

    let currentNavigationItem = this.props.navigation.find(item => item.chapterId === this.chapter.id)
    //let currentNavigationItemIndex = this.props.navigation.indexOf(currentNavigationItem)

    if(nextAspectId > this.chapter.aspects.length) {
      nextRoute = Routes.to('home')

      if(this.chapter.summary) {
        hasSummary = true
      }

      // currentNavigationItemIndex++
      // currentNavigationItem = this.props.navigation[currentNavigationItemIndex]

      // if(currentNavigationItem) {
      //   switch(currentNavigationItem.type) {
      //     case 'chapter':
      //       const nextChapter = this.props.chapters.find(item => item.id === currentNavigationItem.chapterId)
      //       nextRoute = Routes.to('chapter', { chapter: nextChapter.slug })
      //       break

      //     case 'page':
      //       nextRoute = Routes.to('page', { page: currentNavigationItem.slug })
      //       break

      //     default:
      //   }
      // } else {
      //   nextRoute = Routes.to('home')
      // }
    }

    const progress = this.props.progress.find(item => item.id === currentNavigationItem.id)

    if(hasSummary) {
      if(progress.status !== 'done') {
        this.props.accountActions.updateProgress(currentNavigationItem.id, this.chapter.aspects.length + 1)
        this.props.app.willProgress(currentNavigationItem)
      }

      this.props.app.toggleModal(null, 'summary', {
        chapter: this.chapter,
        progress: progress,
      })
    } else {
      if(progress.status !== 'done') {
        this.props.accountActions.updateProgress(currentNavigationItem.id, this.aspect.id)
        this.props.app.willProgress(currentNavigationItem)
      }

      this.props.history.push(nextRoute)
    }
  }

  handleSaveData = data => {
    this.props.accountActions.updateChapters({
      cId: this.chapter.id,
      aId: this.aspect.id,
      data,
    })
  }

  render() {
    if(this.aspect.id) {
      return (
        <Page name="Aspect" theme={this.props.app.theme}>
          <CurrentAspectTemplate
            handleBack={this.handleBack}
            handleNext={this.handleNext}
            chapter={this.chapter}
            aspect={this.aspect}>

            <CurrentChapterAspect
              save={this.handleSaveData}
              data={this.chapterData}
              chapter={this.chapter}
              aspect={this.aspect} />

          </CurrentAspectTemplate>
        </Page>
      )
    }

    else {
      return <Redirect to={Routes.to('chapter', { chapter: this.chapter.slug })} />
    }
  }
}

const CurrentChapterAspect = props => {
  switch(props.aspect.type) {
    case 'article':
    case 'exercise':
      return <AspectArticle {...props} />

    case 'quiz':
      return <AspectQuiz {...props} />

    default:
      return null
  }
}

const CurrentAspectTemplate = props => {
  switch(props.aspect.type) {
    case 'exercise':
      return <AspectExercise {...props} />

    case 'article':
    case 'quiz':
      return <AspectPage {...props} />

    default:
      return null
  }
}

export default withApp(connect(
  (state, props) => ({
    user: state.account.user,
    progress: state.account.progress,
    chapters: state.content.chapters,
    navigation: state.content.navigation,
    chaptersData: state.account.chapters,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(ChapterAspectView))



// WEBPACK FOOTER //
// ./src/components/views/chapters/ChapterAspectView.js